var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-card',{class:[
      _vm.datosEnabled !== -1
        ? 'container_box shadow-1 cursor-pointer'
        : 'container_box_disabled',
      _vm.showTitle ? '' : 'margen',
    ],style:(_vm.widthCard ? `width: ${_vm.widthCard}` : ''),on:{"click":_vm.openURL}},[(_vm.datos.file)?_c('q-img',{class:[_vm.datosEnabled == -1 ? 'disabled' : '', 'Imagen'],attrs:{"src":_vm.imagen ? _vm.imagen.url : require(`@/assets/${_vm.imgDefault}`),"alt":_vm.datos.name,"ratio":1,"contain":""}},[(_vm.datos.name && _vm.showTitle)?_c('div',{staticClass:"Titulo absolute-top text-subtitle text-center"},[_vm._v(" "+_vm._s(_vm.datos.name)+" ")]):_vm._e()]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }